var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-hud game1"},[_c('div',{staticClass:"lightning"}),_vm._l((_vm.checkboxes),function(checked,index){return _c('div',{key:index,staticClass:"checkbox",class:{checked}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }